import styled, {createGlobalStyle, keyframes} from 'styled-components';
import {reloadPage} from '@cip/webapp/appReload';

const GlobalFonts = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Playfair+Display:ital,wght@0,400;0,700;1,400;1,700&display=swap');
`;

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const Wrapper = styled.div`
  font-family: 'Inter', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fafaf9;
  padding: 2rem;
  text-align: center;
  animation: ${fadeUp} 0.6s ease both;
`;

const Title = styled.h1`
  font-family: 'Playfair Display', Georgia, serif;
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: 700;
  color: #111;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-size: 1.1rem;
  font-weight: 300;
  color: #666;
  max-width: 480px;
  line-height: 1.7;
  margin-bottom: 2rem;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: center;
`;

const BackBtn = styled.button`
  padding: 0.75rem 1.75rem;
  background: #8c1515;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition:
    background 0.18s,
    transform 0.15s;

  &:hover {
    background: #a01818;
    transform: translateY(-2px);
  }
`;

const ReloadBtn = styled(BackBtn)`
  background: transparent;
  color: #8c1515;
  border: 1px solid #8c1515;

  &:hover {
    background: rgba(140, 21, 21, 0.08);
  }
`;

interface PaiErrorPageProps {
  /** The error title to display. */
  title?: string;
  /** The error message to display. */
  msg?: string;
}

/** PAI-branded error page shown when an unhandled error occurs. */
export function PaiErrorPage({
  title = 'Something went wrong',
  msg = 'An unexpected error occurred. Please try again.',
}: PaiErrorPageProps) {
  return (
    <>
      <GlobalFonts />
      <Wrapper>
        <div role="alert">
          <Title>{title}</Title>
          <Message>{msg}</Message>
        </div>
        <ButtonRow>
          <BackBtn
            onClick={() => {
              reloadPage({reason: 'error-page'});
            }}
          >
            Reload
          </BackBtn>
          <ReloadBtn
            onClick={() => {
              history.back();
            }}
          >
            Go Back
          </ReloadBtn>
        </ButtonRow>
      </Wrapper>
    </>
  );
}
